// Merge build-time env (import.meta.env) with runtime env (window.__ENV__).
// window.__ENV__ is populated by entrypoint.sh for non-secret config vars only;
// secrets are excluded from that file and come exclusively from import.meta.env.
const _env: Record<string, string> = {
	...(import.meta.env as unknown as Record<string, string>),
	...(typeof window !== "undefined" && window.__ENV__ ? window.__ENV__ : {})
}

export const BASE_URL = _env.VITE_BASE_URL
export const PARTNER_INSIGHTS_API = _env.VITE_PARTNER_INSIGHTS_API
export const VITE_AEM_URL = _env.VITE_AEM_URL
export const USE_SUPER_USER = _env.VITE_USE_SUPER_USER === "true"
export const VITE_AEM_USE_FALLBACK = _env.VITE_AEM_USE_FALLBACK === "true"
export const VITE_USE_SOS_SEARCH_BAR = _env.VITE_USE_SOS_SEARCH_BAR === "true"
export const USE_FORGOT_ACCOUNT = _env.VITE_USE_FORGOT_ACCOUNT === "true"
export const VITE_USE_DINING_CONFLICT = _env.VITE_USE_DINING_CONFLICT === "true"
export const VITE_COUNTRIES_WITH_FLEXPAY = _env.VITE_COUNTRIES_WITH_FLEXPAY
export const VITE_RESTRICTED_COUNTRIES = _env.VITE_RESTRICTED_COUNTRIES
export const VITE_FLAG_CDN_URL =
	_env.VITE_FLAG_CDN_URL || "https://flagcdn.com/"
export const VITE_ACCESS_WITH_EQUOTE = _env.VITE_ACCESS_WITH_EQUOTE
export const VITE_USE_DARK_MODE = _env.VITE_USE_DARK_MODE === "true"
export const VITE_CP_LEGACY_REMOTE = _env.VITE_CP_LEGACY_REMOTE
export const BASE_LEGACY_URL = `${VITE_CP_LEGACY_REMOTE}/remoteCPAccess.do`
export const BASE_LEGACY_URL_LOGOUT = `${VITE_CP_LEGACY_REMOTE}/logout.do`
export const COMPLIANCE_MODAL_SHOWN_KEY = "account-compliance-modal-shown"
export const COMPLIANCE_INTENDED_PATH_STORAGE_KEY =
	"account-compliance-intended-path"
export const COMPLIANCE_COMPLETE_MODAL_SHOWN_KEY =
	"account-compliance-complete-modal-shown"
const _parsedSoftComplianceCutoff = _env.VITE_SOFT_COMPLIANCE_CHECK_CUTOFF_DATE
	? new Date(_env.VITE_SOFT_COMPLIANCE_CHECK_CUTOFF_DATE)
	: null
const _isValidSoftComplianceCutoff =
	_parsedSoftComplianceCutoff !== null &&
	!Number.isNaN(_parsedSoftComplianceCutoff.getTime())
export const SOFT_COMPLIANCE_CHECK_CUTOFF_DATE = _isValidSoftComplianceCutoff
	? _parsedSoftComplianceCutoff
	: null
export const SOFT_COMPLIANCE_CHECK_MODAL_SHOWN_KEY =
	"soft-compliance-check-modal-shown"
export const SOFT_COMPLIANCE_INTENDED_PATH_STORAGE_KEY =
	"soft-compliance-check-intended-path"
export const CREATE_ACCOUNT_LEGACY_URL = `${VITE_CP_LEGACY_REMOTE}/public/registration/choose.do`
export const FORGOT_PASSWORD_LEGACY_URL = `${VITE_CP_LEGACY_REMOTE}/forgotAuthAction.do`
export const AGENCY_PROFILE_LOCATOR_URL = `${VITE_AEM_URL}/public/agencyOnlineProfile.do`
export const CREATE_ACCOUNT_LEGACY_APP_ID = "createAccount"
export const FORGOT_PASSWORD_LEGACY_APP_ID = "forgotPassword"
export const UI_BASE_URL = _env.VITE_UI_BASE_URL || "/"
export const VITE_SHIPBOARD_URL = _env.VITE_SHIPBOARD_URL
export const VITE_SHIPBOARD_MAP_URL = _env.VITE_SHIPBOARD_MAP_URL
export const VITE_EQUOTE_URL = _env.VITE_EQUOTE_URL
export const VITE_AUTH_ENCRYPTION_KEY = _env.VITE_AUTH_ENCRYPTION_KEY
export const ESPRESSO_TOOL_CODE = "CRUISE-MATCH"
export const ROYAL_CARIBBEAN_URL = _env.VITE_VIRTUAL_TOUR_URL
export const CELEBRITY_CRUISES_URL = _env.VITE_CELEBRITY_CRUISES_URL
export const WEBCAST_REGISTRATION_URL = _env.VITE_WEBCAST_REGISTRATION_URL
export const WEBCAST_URL = _env.VITE_WEBCAST_URL
export const WEBCAST_PASS = _env.VITE_WEBCAST_PASS
export const WEBCAST_LOGIN_URL = _env.VITE_WEBCAST_LOGIN_URL
export const ADMIN_CONTACT_TOKEN = _env.VITE_ADMIN_CONTACT_TOKEN
export const VITE_REDIRECT_NEW_MANAGEMENT =
	_env.VITE_REDIRECT_NEW_MANAGEMENT === "true"
export const VITE_USE_PROFILE_IMAGE_SELECTOR =
	_env.VITE_USE_PROFILE_IMAGE_SELECTOR === "true"
export const VITE_USE_LEGAL_ACCEPTANCE =
	_env.VITE_USE_LEGAL_ACCEPTANCE === "true"
export const USE_SIMPLIFIED_SECURITY_SETTINGS_MFA =
	_env.VITE_USE_SIMPLIFIED_SECURITY_SETTINGS_MFA === "true"
export const ENABLE_COMPLIANCE_CHECK =
	_env.VITE_ENABLE_COMPLIANCE_CHECK === "true"
export const REDIRECT_TO_NEW_USER_PROFILE =
	_env.VITE_REDIRECT_TO_NEW_USER_PROFILE === "true"
export const PURCHASE_GIFT_ROYAL_TOOLCODE = "GIFTS-ROYAL-CARIBBEAN"
export const IS_LOWER_EN_ENV = _env.VITE_IS_LOWER_EN_ENV === "false"
export const VITE_LOWER_ENV_USERNAME = _env.VITE_LOWER_ENV_USERNAME
export const VITE_LOWER_ENV_PASSWORD = _env.VITE_LOWER_ENV_PASSWORD

export const VITE_USE_FEATURE_TRANSLATIONS = _env.VITE_USE_FEATURE_TRANSLATIONS
export const FODORS_ENABLED = _env.VITE_FODORS_ENABLED === "true"
// Features flags
export const SHOW_ITINERARY = _env.VITE_SHOW_ITINERARY === "true"
export const SHOW_GROUP_DINING = _env.VITE_SHOW_GROUP_DINING === "true"
export const SHOW_REDUCED_RATES = _env.VITE_SHOW_REDUCED_RATES === "true"
export const SHOW_CONTACT_US = _env.VITE_SHOW_CONTACT_US === "true"
export const SHOW_QUICK_REFERENCE = _env.VITE_SHOW_QUICK_REFERENCE === "true"
export const SHOW_MICROSITES = _env.VITE_SHOW_MICROSITES === "true"
export const VITE_USE_AGENCY_LOCATOR_PROFILE_PREVIEW =
	_env.VITE_USE_AGENCY_LOCATOR_PROFILE_PREVIEW === "true"
export const SHOW_GROUP_TRAVEL_HUB = _env.VITE_SHOW_GROUP_TRAVEL_HUB === "true"
export const SHOW_GROUP_TRAVEL_HUB_TASKS_TAB =
	_env.VITE_SHOW_GROUP_TRAVEL_HUB_TASKS_TAB !== "false"
export const IS_MOCK_VOYAGE_ID = _env.VITE_IS_VOYAGE_ID_MOCKED === "true"
export const VITE_USE_LANGUAGE_PICKER = _env.VITE_USE_LANGUAGE_PICKER === "true"
export const USE_GROUP_NOTES = _env.VITE_USE_GROUP_NOTES === "true"
export const USE_GLOBAL_SEARCH = _env.VITE_USE_GLOBAL_SEARCH === "true"
export const SHOW_MULTI_AGENCY = _env.VITE_SHOW_MULTI_AGENCY !== "false"
export const MULTI_AGENCY_ALLOWED_OFFICES =
	_env.VITE_MULTI_AGENCY_ALLOWED_OFFICES?.split(",") || []
export const MULTI_AGENCY_ALL_OFFICES_ALLOWED =
	MULTI_AGENCY_ALLOWED_OFFICES.some(
		(office) => office.trim().toLowerCase() === "all"
	)
export const SHOW_MMC = _env.VITE_SHOW_MMC === "true"

export const VITE_ENABLE_FORGEROCK_LOGS =
	_env.VITE_ENABLE_FORGEROCK_LOGS === "true"

import SunnyCloudyIcon from "@assets/svg/navigation/weather.svg"

export const Brands = {
	ROYAL: "R",
	CELEBRITY: "C",
	SILVERSEA: "V"
} as const

export enum BRANDS {
	ROYAL = "royal",
	CELEBRITY = "celebrity",
	SILVERSEA = "silversea"
}

export enum BRANDS_NAMES {
	ROYAL = "Royal Caribbean",
	CELEBRITY = "Celebrity Cruises",
	SILVERSEA = "Silversea"
}

export const BrandsValues = {
	R: "R",
	C: "C",
	V: "V"
} as const

export type Brand = (typeof Brands)[keyof typeof Brands] | null

export const APP_ID_PARAM = "p"
export const TOKEN_PARAM = "z"
export const SSO_PARAM = "sso"
export const TOKEN_ID_PARAM = "tokenId"
export const WEBCAST_PARAM = "webcast"
export const allObject = { value: "all", label: "All" }
export const MAX_LOGIN_ATTEMPTS = 5

export const BRANDED_TOOLCODES = {
	HOTELS: {
		code: "HOTELS",
		availableBrands: [Brands.CELEBRITY, Brands.ROYAL]
	},
	"CRUISE-PLANNER": {
		code: "CRUISE-PLANNER",
		availableBrands: [Brands.CELEBRITY, Brands.ROYAL]
	},
	"DIGITAL-BROCHURES": {
		code: "DIGITAL-BROCHURES",
		availableBrands: [Brands.CELEBRITY, Brands.ROYAL, Brands.SILVERSEA]
	},
	"IMAGE-LIBRARY": {
		code: "IMAGE-LIBRARY",
		availableBrands: [Brands.CELEBRITY, Brands.ROYAL]
	}
}

// Error codes
export enum ERROR_CODES {
	INVALID_USERNAME = "unsuccessfulLoginMessage",
	INVALID_CREDENTIALS = "attemptsRemaining",
	ACCOUNT_LOCKED = "accountLockedMessage",
	QAMODE = "qaModeMessage",
	INVALID_TOKEN = "INVALID_TOKEN"
}

export enum FORGEROCK_ERROR_CODES {
	INVALID_USERNAME = "unsuccessfulLoginMessage",
	INVALID_CREDENTIALS = "attemptsRemaining",
	ACCOUNT_LOCKED = "accountLockedMessage",
	QAMODE = "qaModeMessage",
	INVALID_TOKEN = "INVALID_TOKEN",
	FORGEROCK_ERROR = "FORGEROCK_ERROR",
	FORGEROCK_CALLBACK_ERROR = "FORGEROCK_CALLBACK_ERROR"
}

export const MODIFY_AGENT_ACCESS_BTNLABEL = "Modify Agent Access"
export enum Role {
	RCCL = "RCCL",
	RCCLADMIN = "RCCLADMIN",
	ADMIN = "ADMIN"
}

export const USA_CAN_ONLY = ["USA", "CAN", "PRI"]

export const ALL_VALUE = "all"
export const PENDING = "pending"
export const CRUISE_TYPE = {
	CRUISE_ONLY: "CO",
	CRUISE_TOUR: "CT"
} as const
export const DEFAULT_CURRENCY = "USD"

// Promotion types
export const PROMO_TYPE_RESIDENT = "RE"
export const PROMO_TYPE_SENIOR_RESIDENT = "RS"
export const PROMO_TYPE_RESIDENT2 = "R2"
export const PROMO_TYPE_SENIOR = "SR"
export const PROMO_TYPE_SENIOR2 = "S2"
export const PROMO_TYPE_FIREFIGHTERS = "FI"
export const PROMO_TYPE_FIREFIGHTERS2 = "F1"
export const PROMO_TYPE_POLICE = "PO"
export const PROMO_TYPE_POLICE2 = "PL"
export const PROMO_TYPE_MILITARY = "MI"
export const PROMO_TYPE_MILITARY2 = "M1"
export const PROMO_TYPE_COLLECTIVOS = "CV"
export const PROMO_TYPE_CIVIL_SERVANT = "CS"

// Legacy Qualifiers
export const SENIOR_QUALIFIER = "S"
export const FIREFIGHTER_QUALIFIER = "F"
export const MILITARY_QUALIFIER = "M"
export const POLICE_QUALIFIER = "P"

export const CABIN_CLASS = {
	INTERIOR: "INTERIOR",
	OUTSIDE: "OUTSIDE",
	BALCONY: "BALCONY",
	DELUXE: "DELUXE"
} as const

export enum REFUNDABILITY_CODE {
	FULL_AMOUNT = "F",
	DEPOSIT_AMOUNT = "D", //Non refundable
	REFUNDABLE = "R"
}

export const REFUNDABILITY_TYPE = {
	N: "Non-Refundable",
	R: "Refundable",
	B: "Both"
} as const

// Idle timeout constants
export const IDLE_TIMEOUT_SECONDS = 1800000 // 30 minutes in milliseconds  (30 * 60 * 1000)

// Password reset cooldown constants
export const RESEND_COOLDOWN_SECONDS = 300

export const minValueNumberInput = 0.1
export const maxValueNumberInput = 9999
export const WEATHER_DETAILS = {
	icon: SunnyCloudyIcon,
	description: "-",
	temperature: "-",
	wind: "Wind: - / Hum: -"
}

// PI filters constants
export enum DayRange {
	NEXT_10_DAYS = "NEXT_10_DAYS",
	DAYS_11_TO_30 = "DAYS_11_TO_30",
	DAYS_31_TO_60 = "DAYS_31_TO_60",
	DAYS_61_TO_90 = "DAYS_61_TO_90",
	MORE_THAN_90_DAYS = "MORE_THAN_90_DAYS",
	ALL = "ALL",
	REDEEM_WITHIN_120_DAYS = "REDEEM_WITHIN_120_DAYS",
	EXPIRED_WITHIN_120_DAYS = "EXPIRED_WITHIN_120_DAYS",
	INACTIVE_WITHIN_120_DAYS = "INACTIVE_WITHIN_120_DAYS",
	DAYS_10_TO_30 = "DAYS_10_TO_30",
	DAYS_30_TO_60 = "DAYS_30_TO_60",
	DAYS_60_TO_90 = "DAYS_60_TO_90",
	DAYS_90_TO_120 = "DAYS_90_TO_120",
	MORE_THAN_120_DAYS = "MORE_THAN_120_DAYS",
	CANCELLED_PAST_120_DAYS = "CANCELLED_PAST_120_DAYS",
	EXPIRED_WITHIN_48_HS = "EXPIRED_WITHIN_48_HS",
	PAST_SIX_MONTHS = "PAST_SIX_MONTHS"
}

export enum AlertCenterTimeframes {
	NEXT_10_DAYS = "NEXT_10_DAYS",
	DAYS_10_TO_30 = "DAYS_10_TO_30",
	DAYS_30_TO_60 = "DAYS_30_TO_60",
	DAYS_60_TO_90 = "DAYS_60_TO_90",
	DAYS_90_TO_120 = "DAYS_90_TO_120",
	MORE_THAN_120_DAYS = "MORE_THAN_120_DAYS",
	ALL = "ALL"
}

export enum ReservationType {
	ALL = "ALL",
	INDIVIDUAL = "INDIVIDUAL",
	GROUP = "GROUP",
	OPEN = "OPEN",
	CONFIRMED = "CONFIRMED"
}

export enum ScheduledPaymentStatus {
	ALL = "ALL",
	ENROLLED = "Enrolled",
	ELIGIBLE = "Eligible",
	NOT_ELIGIBLE = "Not Eligible"
}

export enum IssueType {
	FINAL_PAYMENT_DUE = "FINAL_PAYMENT_DUE",
	BALANCE_DUE = "BALANCE_DUE",
	EXPIRING_DEPOSIT = "EXPIRING_DEPOSIT",
	EXPIRING_OFFER = "EXPIRING_OFFER",
	EXPIRING_48_HOURS = "EXPIRING_48_HOURS",
	FCC = "FCC",
	CREDIT_EXPIRING_SOON = "CREDIT_EXPIRING_SOON",
	CHECKING_REQUIRED = "CHECKING_REQUIRED",
	DINING_CONFLICT = "DINING_CONFLICT",
	FINANCIAL_ALERTS = "FINANCIAL_ALERTS",
	ALL_OTHER = "ALL_OTHER"
}

export enum IssueTypeMapper {
	FINAL_PAYMENT_DUE = "finalPaymentDue",
	BALANCE_DUE = "balanceDue",
	EXPIRING_DEPOSIT = "nextCruiseExpiringDeposit",
	EXPIRING_OFFER = "nextCruiseExpiringOffer",
	EXPIRING_48_HOURS = "expiringIn48Hours",
	FCC = "fccSailBy",
	CREDIT_EXPIRING_SOON = "creditExpiringSoon",
	CHECKING_REQUIRED = "checkInRequired",
	DINING_CONFLICT = "diningConflict",
	ALL_OTHER = "ALL_OTHER"
}

export enum IssueTypeResult {
	CHECK_IN_REQUIRED = "checkInRequired",
	CREDIT_EXPIRING_SOON = "creditExpiringSoon",
	DESCRIPTION_CHANGE_DINING = "changeDiningTime",
	DESCRIPTION_CHECK_IN_BY = "checkInBy",
	DESCRIPTION_DUE = "due",
	DESCRIPTION_EXPIRES = "expires",
	DESCRIPTION_ON = "on",
	DINING_CONFLICT = "diningConflict",
	EXPIRING_IN_48_HOURS = "expiringIn48Hours",
	EXPIRING_NEXT_CRUISE_DEPOSIT = "expiringNextCruiseDeposit",
	FCC_SAIL_BY = "fccSailBy",
	ICON_TOOLTIP = "viewInAlertCenter",
	NEXT_CRUISE_EXPIRING_OFFER = "nextCruiseExpiringOffer"
}

export enum CompensationType {
	FCC = "FCC",
	ALL_OTHER = "ALL_OTHER"
}

export enum OnboardSaleStatus {
	OPEN = "OPEN",
	CONFIRMED = "CONFIRMED"
}

export const APP_ID = {
	VERB: "VRB",
	EQUOTE: "EQUOTE",
	HYBRIS: "HYBRIS",
	GMU: "GMU",
	IFRNDS: "IFRNDS"
} as const

export const USE_FORGEROCK = _env.VITE_USE_FORGEROCK === "true"
export const USE_RIVER = (_env.VITE_USE_RIVER ?? "true") === "true"
export const HIDE_ALERTS_SECTION = _env.VITE_HIDE_ALERTS_SECTION === "true"
export const SHOW_WIDGET_CUSTOMIZE_BUTTON =
	_env.VITE_SHOW_WIDGET_CUSTOMIZE_BUTTON === "true"

// ForgeRock Configuration Constants
export const WELLKNOWN_URL = _env.VITE_WELLKNOWN_URL
export const JOURNEY_LOGIN = _env.VITE_JOURNEY_LOGIN
export const WEB_OAUTH_CLIENT = _env.VITE_WEB_OAUTH_CLIENT
export const REST_OAUTH_SECRET = _env.VITE_REST_OAUTH_SECRET
export const SERVER_URL = _env.VITE_SERVER_URL
export const SCOPE = _env.VITE_SCOPE
export const REALM_PATH = _env.VITE_REALM_PATH
export const CENTRALIZED_LOGIN = _env.VITE_CENTRALIZED_LOGIN
export const APP_URL =
	typeof window !== "undefined" ? window.location.origin : ""
export const OAUTH_CALLBACK_URL = `${APP_URL}/oauth/callback`
// Supports nested realms: "cpower_sb/cpowerpreprod" -> "realms/cpower_sb/realms/cpowerpreprod"
export const REALM_URL_PATH = (REALM_PATH ?? "")
	.split("/")
	.filter(Boolean)
	.map((segment) => `realms/${segment}`)
	.join("/")
export const OAUTH_END_SESSION_URL = `${SERVER_URL}/oauth2/realms/root/${REALM_URL_PATH}/connect/endSession`

// Intended path constants for authentication flow
export const INTENDED_PATH_STORAGE_KEY = "intendedPath"
export const DEFAULT_INTENDED_PATH = "/home"

export function getBrandKey(value: string): keyof typeof Brands | undefined {
	return (Object.keys(Brands) as Array<keyof typeof Brands>).find(
		(key) => Brands[key] === value
	)
}

export function getBrandNameFromCode(brandValue: string): string {
	return BRANDS_NAMES[getBrandKey(brandValue) as keyof typeof BRANDS_NAMES]
}

export const BRAND_NAME_TO_CODE: Record<string, Brand> = {
	[BRANDS_NAMES.ROYAL]: Brands.ROYAL,
	[BRANDS_NAMES.CELEBRITY]: Brands.CELEBRITY,
	[BRANDS_NAMES.SILVERSEA]: Brands.SILVERSEA
}

export const BRAND_CODE_TO_NAME: Record<Exclude<Brand, null>, string> = {
	[Brands.ROYAL]: BRANDS_NAMES.ROYAL,
	[Brands.CELEBRITY]: BRANDS_NAMES.CELEBRITY,
	[Brands.SILVERSEA]: BRANDS_NAMES.SILVERSEA
}

export const toBrandCodeFromName = (name: string): Brand => {
	return BRAND_NAME_TO_CODE[name] || null
}

export const toBrandNameFromCode = (code: Brand): string => {
	if (!code) return ""
	return BRAND_CODE_TO_NAME[code as Exclude<Brand, null>]
}

export const YOUTUBE_URL = {
	embed: "https://www.youtube.com/embed/",
	controls: "?controls=0",
	thumbnail: "https://img.youtube.com/vi/",
	thumbnailName: "/default.jpg"
}

export const HTTPS_PREFIX = "https"
export const MEDIA_URL = {
	Royal: "https://royalcaribbean.com",
	CruisingPower: "https://media.cruisingpower.com"
}

export const MFA_METHODS = {
	EMAIL: "EMAIL",
	SMS: "SMS"
} as const

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const WEBSITE_DOMAIN_REGEX =
	/^(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s?#]*)?(?:\?[^\s#]*)?(?:#[^\s]*)?$/
